import React from "react";
import { useTranslationStore } from "../../../state/useTranslationStore";

interface Translation {
    original_text: string;
    translated_text: string;
    language_code: string;
    language_name: string;
}

type Props = {
    data: Translation[];
    handlerAddLangauge: (code: string, lan: string) => void;
    disabled: boolean;
};

const AddLanguageButton = (props: Props) => {
    const [code, setCode] = React.useState("");
    const [lan, setLan] = React.useState("");
    const { prayer_names, activeLanguage } = useTranslationStore();

    // Set initial values based on activeLanguage
    React.useEffect(() => {
        const activeLang = prayer_names.find(codes => codes.language_code === activeLanguage);
        if (activeLang) {
            setCode(activeLang.language_code);
            setLan(activeLang.language_name);
        }
    }, [activeLanguage, prayer_names]);

    return (
        <div className="flex items-center gap-2 w-full">
            <input
                value={code}
                onInput={(e: React.FormEvent<HTMLInputElement>) =>
                    setCode(e.currentTarget.value)
                }
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    setCode(e.currentTarget.value)
                }
                placeholder="Language Code: en"
                type="text"
                className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
                value={lan}
                onInput={(e: React.FormEvent<HTMLInputElement>) =>
                    setLan(e.currentTarget.value)
                }
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                    setLan(e.currentTarget.value)
                }
                placeholder="Language Name: English"
                type="text"
                className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
                disabled={props.disabled}
                onClick={() => props.handlerAddLangauge(code, lan)}
                className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Add Language
            </button>
        </div>
    );
};

export default AddLanguageButton;